const menus = [
    {
        name: "首页",
        path: "/dashboard",
    },
    {
        name: "订单列表",
        path: "/orderList",
    },
    {
        name: "退款列表",
        path: "/refundList",
    },
    {
        name: "兑换列表",
        path: "/voucherList",
    },
    {
        name: "用户列表",
        path: "/userList",
    },
    {
        name: "搜索记录列表",
        path: "/searchList",
    },
    {
        name: "抽奖记录",
        path: "/prizeList",
    },
    {
        name: "活跃用户列表",
        path: "/footPrintList",
    },
    {
        name: "角色列表",
        path: "/manageList",
    },
    {
        name: "创建角色",
        path: "/createUser",
    },
    {
        name: "创建项目",
        path: "/scenicList",
    },
    {
        name: "创建管理员",
        path: "/createAdmin",
    },
    {
        name: "渠道运营管理",
        path: "/bindWeChat",
    },
    {
        name: "收入统计",
        path: "/totalData",
    },
    {
        name: "项目收入统计",
        path: "/projectTotalData",
    },
    {
        name: "分账日志",
        path: "/subdivisionLog",
    },
    {
        name: "财务统计",
        path: "/financialStatistics",
    },
    {
        name: "财务统计分析",
        path: "/newFinancialStatistics",
    },
    {
        name: "行为分析",
        path: "/behavioralStatistics",
    },
    {
        name: "渠道统计",
        path: "/channelStatistics",
    },
]


export default menus


// WEBPACK FOOTER //
// ./src/assets/js/menu.js